import { AppUserType } from '~/enums/permissions/_types';

export default () => {
    const { can } = usePermissions();

    return {
        canCreate: () => can(AppUserType.Admin, AppUserType.Client),
        canOverview: () => can(AppUserType.Admin, AppUserType.Client, AppUserType.Student),
        canDetail: () => can(AppUserType.Admin, AppUserType.Client, AppUserType.Student),
    };
};
